import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalErrorService } from 'src/app/services/shared/modal-error.service';
import { Error, getSectionPath,errorsCodesDeleteManager, errorsCodesDeletePersonaToManager, errorsCodesFromManagerToPersona, errorsCodesCompanyCoversSections } from 'src/app/models/error';
import { ActivatedRoute, Router } from '@angular/router';
import { PersonProfileCompany } from 'src/app/models/persona/profile/personProfileCompany';
import { DatePipe } from '@angular/common';
import { SectionNamePipe } from 'src/app/ui/directives/section.pipe';
@Component({
  selector: 'app-modal-error',
  templateUrl: './modal-error.component.html',
  styleUrls: ['./modal-error.component.scss'],
  providers: [DatePipe,SectionNamePipe]
})
export class ModalErrorComponent implements OnInit {
  public userCompany:PersonProfileCompany;
  public dateNow;
  public dateStartCompany: any;
  public dateEndCompany: any;
  public modalRef: any;
  public errors: Error[];
  public responseErrorDel: any;
  public errorHandle: boolean =false;
  public getUserProfile: any;
  public checkTypeArgs: any;
  public checkErrorsCode: any;
  public getUrl:any;
  public stringArgs: string="";
  public errorsCodesDeleteManager: any = errorsCodesDeleteManager;
  public errorsCodesDeletePersonaToManager: any = errorsCodesDeletePersonaToManager;
  public errorsCodesFromManagerToPersona: any = errorsCodesFromManagerToPersona;
  public errorsCodesCompanyCoversSections: any = errorsCodesCompanyCoversSections;

  @ViewChild('content') content: TemplateRef<any>;

  private modal_opened = false;

  constructor(
    private modalService: NgbModal, 
    public modalErrorService: ModalErrorService, 
    public router: Router, 
    public route: ActivatedRoute
  ) {
    this.getUrl=(args:any, code:any):string | void=>{
      let section="";
      let personaId="";
      let secId="";
      if(errorsCodesDeleteManager.includes(code)){
        section= getSectionPath(args.identifier_source);
        personaId=args.persona_identifier;
        secId=args.identifier;
      }else if(errorsCodesDeletePersonaToManager.includes(code)){
        section= "/profile";
        personaId=args.manager_identifier;
      }else if(errorsCodesFromManagerToPersona.includes(code)){
        section= "/profile/company/";
        personaId=args.persona_identifier;
        secId=args.company_profile_identifier;
      }else if(errorsCodesCompanyCoversSections.includes(code)){
        section= getSectionPath(args.section_identifier_source);
        personaId=args.persona_identifier;
        secId=args.section_identifier;
      }
      return secId? "/persona/"+personaId+section+secId:"/persona/"+personaId+section;
    };
    
    this.getUserProfile=(args:any, code:any)=>{
       const redirectUrl= this.getUrl(args,code);
       if(redirectUrl){
        let redirect =window.open(redirectUrl, "_blank");
        if(!(redirect)){
          this.close();
          document.getElementById('blanket')?.classList?.add('d-none');
          document.querySelector('.blanket-active')?.classList?.remove('blanket-active');
          this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
            this.router.navigate([redirectUrl]);
          });  
        }else{
          redirect.opener=null;
        }

      } 
    };
    this.checkTypeArgs=(err :string)=>{
      if(this.errors[err].codeArgs){
        if(!Array.isArray(this.errors[err].codeArgs)){
          let arr=[];
          arr.push(this.errors[err].codeArgs);
          this.errors[err].codeArgs= arr;
        }
      }else{
        this.errors[err].codeArgs=[];
      }

    }
    this.checkErrorsCode =(err :string):boolean =>
      errorsCodesDeleteManager.includes(this.errors[err].code) ||
      errorsCodesDeletePersonaToManager.includes(this.errors[err].code) ||
      errorsCodesCompanyCoversSections.includes(this.errors[err].code) ||
      errorsCodesFromManagerToPersona.includes(this.errors[err].code) ;
  }

  ngOnInit(): void {
    this.modalErrorService.sharedModalOpen.subscribe((value) => {
      this.userCompany= new PersonProfileCompany();
      this.errors = value;
      if (Object.keys(this.errors).length > 0 && !this.modal_opened) {
        for(let error in this.errors){
          this.errorHandle=this.checkErrorsCode(error);
          this.checkTypeArgs(error);
          if(!this.errorHandle && this.errors[error].codeArgs.length>0){
            this.stringArgs = JSON.stringify(this.errors[error].codeArgs,null, "\t");
          }
        }      
        if(this.userCompany?.dateStart){
          this.dateStartCompany= this.userCompany.dateStart;
          this.dateEndCompany= this.userCompany.dateEnd;
        }
        this.dateNow=`${new Date().getFullYear()}-${(new Date().getMonth()+1).toString().length ==1?'0'+(new Date().getMonth()+1).toString():new Date().getMonth()+1}-${new Date().getDate().toString().length ==1?'0'+new Date().getDate().toString():new Date().getDate()}`.toString();
        
        this.open();
      }
    });
  }
  open() {
    this.modal_opened = true;
    this.modalRef = this.modalService.open(this.content, { ariaLabelledBy: 'error-modal', backdropClass: 'backdrop-modal-error' });
    this.modalRef.result.then(() => {}, () => { this.close()})
  }

  close() {
    this.modalErrorService.cleanErrors();
    this.modal_opened = false;
    this.modalRef.dismiss();
  }

  confirm() {
    this.modalErrorService.cleanErrors();
    this.modal_opened = false;
    this.close();
  }
  
}
